var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"https://t.me/info_profitads","target":"_blank"}},[_c('img',{attrs:{"src":require("../../assets/icons/icon-telegram.svg"),"alt":"telegram icon"}}),_c('div',{staticClass:"outside-link__content"},[_c('p',[_vm._v(_vm._s(_vm.$t('linkElement.text1')))]),_c('p',[_vm._v(_vm._s(_vm.$t('linkElement.text2')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }